export class CoasVideoPreview {
    constructor(containerVideoId) {
        this.containerVideoId = containerVideoId;
    }
    onInit() {
        const containerVideo = document.getElementById(this.containerVideoId);
        if (!containerVideo)
            return console.log(`Not element fount with '${this.containerVideoId}' Id`);
        const imgPreview = containerVideo.getAttribute('srcImg');
        const ytVideoCode = containerVideo.getAttribute('srcVideoCode');
        if (!ytVideoCode)
            return console.log(`Not YT code with '${ytVideoCode}' value`);
        const internalContent = `<div class="video-container-image">` +
            `<img class="relative z-10 w-full" src="${imgPreview}" loading="lazy" alt="landing video">` +
            `</div>`;
        containerVideo.innerHTML = internalContent;
        const myImage = containerVideo.querySelector('div.video-container-image');
        myImage && this.clickPosterVideo(myImage, ytVideoCode, containerVideo);
    }
    clickPosterVideo(imageReference, ytVideoCode, containerVideo) {
        var _a;
        const landingPosterVideo = imageReference;
        const playButton = (_a = containerVideo.parentElement) === null || _a === void 0 ? void 0 : _a.querySelector('.abi__card-info-play');
        const handleClick = () => {
            var _a, _b, _c, _d;
            (_a = containerVideo.parentElement) === null || _a === void 0 ? void 0 : _a.classList.add("played");
            // Add the YouTube iframe to the div with id="youtube-modal"
            const youtubeModal = document.getElementById('youtube-modal');
            (_c = (_b = youtubeModal === null || youtubeModal === void 0 ? void 0 : youtubeModal.parentElement) === null || _b === void 0 ? void 0 : _b.parentElement) === null || _c === void 0 ? void 0 : _c.classList.add("active");
            if (youtubeModal) {
                // Create a div with the ID that matches ytVideoCode for the YouTube player to use
                youtubeModal.innerHTML = `<div id="${ytVideoCode}"></div>`;
                // Call the YouTube API function to initialize the player
                this.onYouTubeIframeAPIReady(ytVideoCode);
                // Add an event listener to the close button to remove the video when clicked
                const closeButton = (_d = youtubeModal.closest('.youtube-modal-wrapper')) === null || _d === void 0 ? void 0 : _d.querySelector('[data-modal-hide="default-modal"]');
                if (closeButton) {
                    closeButton.addEventListener('click', () => {
                        var _a, _b;
                        youtubeModal.innerHTML = ''; // Clear the video content
                        (_b = (_a = youtubeModal === null || youtubeModal === void 0 ? void 0 : youtubeModal.parentElement) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.classList.remove("active");
                    });
                }
            }
        };
        if (landingPosterVideo) {
            landingPosterVideo.addEventListener('click', handleClick);
        }
        if (playButton) {
            playButton.addEventListener('click', handleClick);
        }
    }
    onYouTubeIframeAPIReady(videoID) {
        this.player = new window.YT.Player(videoID, {
            videoId: `${videoID}`,
            playerVars: {
                'autoplay': 1,
                'origin': `${window.location.href}`
            },
        });
    }
}
